export const iconFontAwesomeAlertRadiation = (
	<i className="fa-solid fa-radiation"></i>
);
